import React, { createContext, useContext, useState, ReactNode } from 'react';

export enum FooterButtonPosition {
    LEFT = 'left',
    MIDDLE = 'middle',
    RIGHT = 'right',
}

type FooterButtonMap = {
    [key in FooterButtonPosition]?: ReactNode;
};

interface HomeFooterContextProps {
    footerButtons: FooterButtonMap;
    setFooterButton: (position: FooterButtonPosition, button: ReactNode | null) => void;
    clearFooterButtons: () => void;
}

const HomeFooterContext = createContext<HomeFooterContextProps | undefined>(undefined);

export const HomeFooterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [footerButtons, setFooterButtons] = useState<FooterButtonMap>({});

    const setFooterButton = (position: FooterButtonPosition, button: ReactNode | null) => {
        setFooterButtons(prev => ({
            ...prev,
            [position]: button || undefined,
        }));
    };

    const clearFooterButtons = () => {
        setFooterButtons({});
    };

    return (
        <HomeFooterContext.Provider value={{ footerButtons, setFooterButton, clearFooterButtons }}>
            {children}
        </HomeFooterContext.Provider>
    );
};

export const useHomeFooter = (): HomeFooterContextProps => {
    const context = useContext(HomeFooterContext);
    if (!context) {
        throw new Error('useHomeFooter must be used within a HomeFooterProvider');
    }
    return context;
};
